import styled from 'styled-components'

export const TabsContainer = styled.div`
    display: flex;
    /* 2024-09-12 17:23:09 灿白说去掉的 */
    /* gap: 10px; */
    transform: translateY(1px);
`
